module.exports = __webpack_public_path__ + "img/icon-safari.312ca97c.svg";